import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const VUEX_PROPERTIES = ['state', 'getters', 'actions', 'mutations']

let store = {};

(function updateModules () {
  store = normalizeRoot(require('../store/index.js'), 'store/index.js')

  // If store is an exported method = classic mode (deprecated)

  // Enforce store modules
  store.modules = store.modules || {}

  resolveStoreModules(require('../store/accesstokens.js'), 'accesstokens.js')
  resolveStoreModules(require('../store/acts.js'), 'acts.js')
  resolveStoreModules(require('../store/adminacts.js'), 'adminacts.js')
  resolveStoreModules(require('../store/admindocuments.js'), 'admindocuments.js')
  resolveStoreModules(require('../store/admininvoices.js'), 'admininvoices.js')
  resolveStoreModules(require('../store/adminorganizations.js'), 'adminorganizations.js')
  resolveStoreModules(require('../store/adminorganizationusers.js'), 'adminorganizationusers.js')
  resolveStoreModules(require('../store/adminparticipants.js'), 'adminparticipants.js')
  resolveStoreModules(require('../store/adminperiods.js'), 'adminperiods.js')
  resolveStoreModules(require('../store/adminsignatures.js'), 'adminsignatures.js')
  resolveStoreModules(require('../store/admintags.js'), 'admintags.js')
  resolveStoreModules(require('../store/admintariffs.js'), 'admintariffs.js')
  resolveStoreModules(require('../store/admintemplates.js'), 'admintemplates.js')
  resolveStoreModules(require('../store/archivetriggers.js'), 'archivetriggers.js')
  resolveStoreModules(require('../store/billing.js'), 'billing.js')
  resolveStoreModules(require('../store/clientbalances.js'), 'clientbalances.js')
  resolveStoreModules(require('../store/comments.js'), 'comments.js')
  resolveStoreModules(require('../store/contacts.js'), 'contacts.js')
  resolveStoreModules(require('../store/dialogs.js'), 'dialogs.js')
  resolveStoreModules(require('../store/documentlogs.js'), 'documentlogs.js')
  resolveStoreModules(require('../store/documents.js'), 'documents.js')
  resolveStoreModules(require('../store/documentstatuses.js'), 'documentstatuses.js')
  resolveStoreModules(require('../store/documenttypes.js'), 'documenttypes.js')
  resolveStoreModules(require('../store/edsKeys.js'), 'edsKeys.js')
  resolveStoreModules(require('../store/folders.js'), 'folders.js')
  resolveStoreModules(require('../store/ghosts.js'), 'ghosts.js')
  resolveStoreModules(require('../store/integrations.js'), 'integrations.js')
  resolveStoreModules(require('../store/invoices.js'), 'invoices.js')
  resolveStoreModules(require('../store/organizations.js'), 'organizations.js')
  resolveStoreModules(require('../store/organizationusers.js'), 'organizationusers.js')
  resolveStoreModules(require('../store/participants.js'), 'participants.js')
  resolveStoreModules(require('../store/payments.js'), 'payments.js')
  resolveStoreModules(require('../store/peopleforce.js'), 'peopleforce.js')
  resolveStoreModules(require('../store/profilemenu.js'), 'profilemenu.js')
  resolveStoreModules(require('../store/reconciliationacts.js'), 'reconciliationacts.js')
  resolveStoreModules(require('../store/savedroutes.js'), 'savedroutes.js')
  resolveStoreModules(require('../store/sessions.js'), 'sessions.js')
  resolveStoreModules(require('../store/signatures.js'), 'signatures.js')
  resolveStoreModules(require('../store/stories.js'), 'stories.js')
  resolveStoreModules(require('../store/tags.js'), 'tags.js')
  resolveStoreModules(require('../store/taxbills.js'), 'taxbills.js')
  resolveStoreModules(require('../store/templatefields.js'), 'templatefields.js')
  resolveStoreModules(require('../store/templates.js'), 'templates.js')
  resolveStoreModules(require('../store/tranzzo.js'), 'tranzzo.js')
  resolveStoreModules(require('../store/users.js'), 'users.js')
  resolveStoreModules(require('../store/plugins/ability.js'), 'plugins/ability.js')
  resolveStoreModules(require('../store/plugins/vuex-orm.js'), 'plugins/vuex-orm.js')

  // If the environment supports hot reloading...
})()

// createStore
export const createStore = store instanceof Function ? store : () => {
  return new Vuex.Store(Object.assign({
    strict: (process.env.NODE_ENV !== 'production')
  }, store))
}

function normalizeRoot (moduleData, filePath) {
  moduleData = moduleData.default || moduleData

  if (moduleData.commit) {
    throw new Error(`[nuxt] ${filePath} should export a method that returns a Vuex instance.`)
  }

  if (typeof moduleData !== 'function') {
    // Avoid TypeError: setting a property that has only a getter when overwriting top level keys
    moduleData = Object.assign({}, moduleData)
  }
  return normalizeModule(moduleData, filePath)
}

function normalizeModule (moduleData, filePath) {
  if (moduleData.state && typeof moduleData.state !== 'function') {
    console.warn(`'state' should be a method that returns an object in ${filePath}`)

    const state = Object.assign({}, moduleData.state)
    // Avoid TypeError: setting a property that has only a getter when overwriting top level keys
    moduleData = Object.assign({}, moduleData, { state: () => state })
  }
  return moduleData
}

function resolveStoreModules (moduleData, filename) {
  moduleData = moduleData.default || moduleData
  // Remove store src + extension (./foo/index.js -> foo/index)
  const namespace = filename.replace(/\.(js|mjs)$/, '')
  const namespaces = namespace.split('/')
  let moduleName = namespaces[namespaces.length - 1]
  const filePath = `store/${filename}`

  moduleData = moduleName === 'state'
    ? normalizeState(moduleData, filePath)
    : normalizeModule(moduleData, filePath)

  // If src is a known Vuex property
  if (VUEX_PROPERTIES.includes(moduleName)) {
    const property = moduleName
    const propertyStoreModule = getStoreModule(store, namespaces, { isProperty: true })

    // Replace state since it's a function
    mergeProperty(propertyStoreModule, moduleData, property)
    return
  }

  // If file is foo/index.js, it should be saved as foo
  const isIndexModule = (moduleName === 'index')
  if (isIndexModule) {
    namespaces.pop()
    moduleName = namespaces[namespaces.length - 1]
  }

  const storeModule = getStoreModule(store, namespaces)

  for (const property of VUEX_PROPERTIES) {
    mergeProperty(storeModule, moduleData[property], property)
  }

  if (moduleData.namespaced === false) {
    delete storeModule.namespaced
  }
}

function normalizeState (moduleData, filePath) {
  if (typeof moduleData !== 'function') {
    console.warn(`${filePath} should export a method that returns an object`)
    const state = Object.assign({}, moduleData)
    return () => state
  }
  return normalizeModule(moduleData, filePath)
}

function getStoreModule (storeModule, namespaces, { isProperty = false } = {}) {
  // If ./mutations.js
  if (!namespaces.length || (isProperty && namespaces.length === 1)) {
    return storeModule
  }

  const namespace = namespaces.shift()

  storeModule.modules[namespace] = storeModule.modules[namespace] || {}
  storeModule.modules[namespace].namespaced = true
  storeModule.modules[namespace].modules = storeModule.modules[namespace].modules || {}

  return getStoreModule(storeModule.modules[namespace], namespaces, { isProperty })
}

function mergeProperty (storeModule, moduleData, property) {
  if (!moduleData) {
    return
  }

  if (property === 'state') {
    storeModule.state = moduleData || storeModule.state
  } else {
    storeModule[property] = Object.assign({}, storeModule[property], moduleData)
  }
}
